export const SAVED_QUERIES = 'SAVED_QUERIES';